import { useCallback } from 'react';
import { useBottomSheetPageId } from '../../../providers/BottomSheetPageIdProvider';
import { useSheetStack } from './useSheetStack';
/**
 * Returns a dismisser for the managed sheet page hosting this content. Closes that page by its
 * identity, so pages the dismissed content pushed on top of it are left open. No-ops when the
 * content is not hosted in a managed stack page (e.g. a standalone declarative BottomSheet).
 */ export function useCloseHostingBottomSheetPage() {
    const { removeBottomSheetPage } = useSheetStack();
    const hostingPageId = useBottomSheetPageId();
    return useCallback(()=>{
        if (hostingPageId != null) {
            removeBottomSheetPage(hostingPageId);
        }
    }, [
        hostingPageId,
        removeBottomSheetPage
    ]);
}
